/*

*/
import { createRef } from "react";
const useCapture = (props) => {
  //  This function retrieves camera info and sets it to record to the canvas
  function onStream(mediaIn, type) {
    try {
      let newObj = {
        mediaSourceRef: createRef(),
        // Global properties
        editable: false,
        properties: {
          name: type,
        },
      };
      var tracks = mediaIn.getVideoTracks();
      for (var trk in tracks) {
        var cap = tracks[trk].getCapabilities();
        var cnstr = {};
        if (cap.frameRate && cap.frameRate.max) {
          cnstr.frameRate = {
            ideal: cap.frameRate.max,
            min: cap.frameRate.min,
            max: cap.frameRate.max > 30 ? 30 : cap.frameRate.max,
          };
        }
        tracks[trk].applyConstraints(cnstr);
        let setts = tracks[trk].getSettings();
        console.log("adding video ", setts);
        newObj.properties.framerate = setts.frameRate;
        newObj.properties.height = setts.height;
        newObj.properties.width = setts.width;
      }
      console.log("added ", tracks);

      newObj.mediaSourceRef.current = mediaIn;
      props.callback(newObj);
    } catch (e) {
      console.log("Capa errror (ignoring):", e);
    }
  }

  function addCamera() {
    navigator.mediaDevices
      .getUserMedia({
        audio: true,
        video: {
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      })
      .then(function (stream) {
        onStream(stream, "cam+mic");
      })
      .catch(function (e) {
        console.error("Could not get cam+mic.", e);
        try {
          navigator.mediaDevices
            .getUserMedia({ audio: false, video: true })
            .then(function (stream) {
              onStream(stream, "cam");
            })
            .catch(function (e) {
              console.error("Could not get just cam.", e);
              navigator.mediaDevices
                .getUserMedia({ audio: true, video: false })
                .then(function (stream) {
                  onStream(stream, "mic");
                })
                .catch(function (e) {
                  console.error("Could not get just mic.", e);
                });
            });
        } catch (e) {
          console.error(e);
        }
      });
  }

  function addScreenShare() {
    navigator.mediaDevices
      .getDisplayMedia({
        audio: true,
        video: true,
      })
      .then(function (stream) {
        onStream(stream, "screenshare");
      })
      .catch(function (e) {
        console.error("Could not start screen share: ", e);
      });
  }
  return [addCamera, addScreenShare];
};

export default useCapture;
